export const studentI18n = {
    en: {
        searchTitle: 'Search',
        clear: 'Clear',
        unassigned: 'Unassigned',
        search: 'Search by username, email, names',
        title: 'Students for {institution} institution',
        errors: {
            userNoAdded: 'The user could not be added to the institution.'
        },
        selectClass: 'Select class',
        viewClasses: 'View Classes',
        headers: {
            name: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            status: 'Status',
            classes: 'Classes'
        },
        class: {
            headers: {
                name: 'Name',
                action: 'Action',
            },
            title: '{name}\'s Classes',
        },
        info:{
            goBack: 'Go Back',
            title: 'User Information',
            username: 'Username',
            email: 'Email Address',
            firstName: 'First Name',
            lastName: 'Last Name',
            middleName: 'Middle name',
            address: 'Address',
            city: 'City',
            state: 'State/Province',
            zipcode: 'Zip/Postal Code',
            country: 'Country',
            phone: 'Phone Number',
            phoneExt: 'Ext.'
        },
        table:{
            add: 'Add to class',
            added: 'Added to class',
            remove: 'Delete from class'
        }
    },
    es: {
        searchTitle: 'Buscar',
        clear: 'Clear',
        unassigned: 'Sin asignar',
        search: 'Buscar por nombre de usuario, correo electrónico, nombres',
        title: 'Estudiantes para la institución {institution}',
        errors: {
            userNoAdded: 'El usuario no pudo ser agregado con éxito.'
        },
        selectClass: 'Seleccione la clase',
        viewClasses: 'Ver Clases',
        headers: {
            name: 'Primer Nombre',
            lastName: 'Apellido',
            email: 'Correo',
            status: 'Estado',
            classes: 'Clases'
        },
        class: {
            headers: {
                name: 'Nombre',
                action: 'Acción',
            },
            title: 'Clases de {name}',
        },
        info:{
            goBack: 'Atrás',
            title: 'Información de Usuario',
            username: 'Nombre de Usuario',
            email: 'Correo Electrónico',
            firstName: 'Nombre',
            middleName: 'Segundo Nombre',
            lastName: 'Apellido',
            address: 'Dirección',
            city: 'Ciudad',
            state: 'Estado/Provincia',
            zipcode: 'Código Postal',
            country: 'País',
            phone: 'Teléfono',
            phoneExt: 'Extensión'
        },
        table:{
            add: 'Adicionar a la clase',
            added: 'Adicionado a la clase',
            remove: 'Borrar de la clase'
        }

    }
}
